import { get } from 'lodash';

export default opportunities => ({
  ...opportunities,
  results: opportunities.results.map(opportunity => ({
    ...opportunity,
    name: `${opportunity.title} - (${get(opportunity, 'sequence.campaign.name', 'Campaign unk')})`,
  })),
});
